module.exports = __webpack_public_path__ + "assets/img/s2-tab-1-active-0e657699.png";